module.exports = __webpack_public_path__ + "static/media/mychips.b5a91a03.png";